export default {"src":"/_next/static/image/public/images/social_youTube_white.304fc8247e47de1035f7661e31c2e5b2.svg","height":11,"width":17};